import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/utils/nav'

import router from '@/router'
import routers from '@/router/routers'
const homeName = '首页'

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    errorCount: state => state.errorList.length
  },
  mutations: {
    setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
    setTagNavList(state, list) {
      let tagList = []
      if (list) {
        tagList = [...list.filter((o) => o.name || (o.meta && o.meta.title))]
      } else tagList = getTagNavListFromLocalstorage() || []
      // 如果进行系统默认进入首页, 放开注释
      // if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag(state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag(state, { route, type = 'unshift' }) {
      let r = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, r)) {
        if (type === 'push') state.tagNavList.push(r)
        else {
          if (r.name === homeName) state.tagNavList.unshift(r)
          else state.tagNavList.splice(1, 0, r)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    clearTag(state) {
      const tagNavList = state.tagNavList.filter((o) => o.name === homeName)
      if (tagNavList.findIndex((o) => o.name === homeName) < 0) {
        tagNavList.push({
          name: homeName,
          meta: { title: homeName },
          params: {},
          query: {}
        })
      }
      state.tagNavList = tagNavList
      setTagNavListInLocalstorage(tagNavList)
    },
    setLocal(state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError(state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tagsNav.js